<div class="page-container"> 
	<div class="display-2" *ngIf="registered===true">
		<span>You have registered successfully and verification has been initiated. Kindly wait for the verification email.</span>
	</div>
	<div *ngIf="registered!=true">
		<app-expert-profile [id]="user.id" *ngIf="user" (completed)="onCompleted()"></app-expert-profile>
	</div>
</div>